import React, {
    useEffect,
    useMemo,
    useState,
} from "react";

import {
    useNavigate,
} from "react-router-dom";

// import * as b2cleadService from "../../Services/b2cleadService";
import * as b2bleadService from "../../Services/b2bleadService";

export const B2BPlanQuations = () => {

    const navigate =
        useNavigate();

    const [plans, setPlans] =
        useState([]);

    const [customPlans, setCustomPlans] =
        useState([]);

    const [loading, setLoading] =
        useState(false);

    const [planSearch, setPlanSearch] =
        useState("");

    const [customSearch, setCustomSearch] =
        useState("");

    // =====================================
    // GET DATA
    // =====================================

    useEffect(() => {

        getPlans();

        getCustomPlans();

    }, []);

    const getPlans =
        async () => {

            try {

                setLoading(true);

                const res =
                    await b2bleadService.getAllPlans();

                if (
                    res?.data?.status
                ) {

                    setPlans(
                        res?.data
                            ?.data || []
                    );

                }

            } catch (error) {

                console.log(error);

            } finally {

                setLoading(false);

            }

        };

    const getCustomPlans =
        async () => {

            try {

                const res =
                    await b2bleadService.getAllCustomPlans();

                if (
                    res?.data?.status
                ) {

                    setCustomPlans(
                        res?.data
                            ?.data || []
                    );

                }

            } catch (error) {

                console.log(error);

            }

        };

    // =====================================
    // SEARCH FILTERS
    // =====================================

    const filteredPlans =
        useMemo(() => {

            return plans.filter(
                (item) => {

                    return `
                        ${item?.planId}
                        ${item?.planName}
                    `
                        .toLowerCase()
                        .includes(
                            planSearch.toLowerCase()
                        );

                }
            );

        }, [
            plans,
            planSearch,
        ]);

    const filteredCustomPlans =
        useMemo(() => {

            return customPlans.filter(
                (item) => {

                    return `
                        ${item?.id}
                        ${item?.planName}
                        ${item?.employee?.firstName}
                        ${item?.employee?.lastName}
                    `
                        .toLowerCase()
                        .includes(
                            customSearch.toLowerCase()
                        );

                }
            );

        }, [
            customPlans,
            customSearch,
        ]);

    // =====================================
    // NAVIGATION
    // =====================================

    const viewPlan = (
        planId
    ) => {

        navigate(
            `/plans/${planId}`
        );

    };

    const viewCustomPlan = (
        customId
    ) => {

        navigate(
            `/customPlan/${customId}`
        );

    };

    return (

        <div className="row g-4">

            {/* ===================================== */}
            {/* STANDARD PLANS */}
            {/* ===================================== */}

            <div className="col-12">

                <div className="card border-0 shadow-sm rounded-4 overflow-hidden">

                    <div className="card-header bg-white border-bottom p-4">

                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

                            <div>

                                <h4 className="fw-bold mb-1">
                                    Standard Plans
                                </h4>

                                <p className="text-muted mb-0">
                                    View all available plans
                                </p>

                            </div>

                            <span className="badge bg-primary rounded-pill px-3 py-2">

                                Total :
                                {" "}
                                {
                                    filteredPlans?.length
                                }

                            </span>

                        </div>

                    </div>

                    <div className="card-body p-4">

                        {/* SEARCH */}

                        <div className="row mb-4">

                            <div className="col-lg-3">

                                <div className="position-relative">

                                    <i
                                        className="fe fe-search position-absolute"
                                        style={{
                                            top: "50%",
                                            left: "18px",
                                            transform:
                                                "translateY(-50%)",
                                            color:
                                                "#6c757d",
                                        }}
                                    />

                                    <input
                                        type="text"
                                        className="form-control rounded-pill border-0 shadow-sm ps-5 py-3"
                                        placeholder="Search standard plans..."
                                        value={
                                            planSearch
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setPlanSearch(
                                                e
                                                    .target
                                                    .value
                                            )
                                        }
                                        style={{
                                            background:
                                                "#f8fafc",
                                        }}
                                    />

                                </div>

                            </div>

                        </div>

                        {/* TABLE */}

                        <div
                            className="table-responsive border rounded-4"
                            style={{
                                maxHeight:
                                    "500px",
                                overflowY:
                                    "auto",
                            }}
                        >

                            <table className="table align-middle mb-0">

                                <thead
                                    style={{
                                        background:
                                            "#f8fafc",
                                        position:
                                            "sticky",
                                        top: 0,
                                        zIndex: 2,
                                    }}
                                >

                                    <tr>

                                        <th className="text-center py-3">
                                            Plan ID
                                        </th>

                                        <th className="text-center py-3">
                                            Plan Name
                                        </th>

                                        <th className="text-center py-3">
                                            Action
                                        </th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {filteredPlans?.length >
                                        0 ? (

                                        filteredPlans.map(
                                            (
                                                item
                                            ) => (

                                                <tr
                                                    key={
                                                        item?.planId
                                                    }
                                                >

                                                    <td className="text-center fw-semibold py-3">

                                                        {
                                                            item?.planId
                                                        }

                                                    </td>

                                                    <td className="text-center fw-semibold py-3">

                                                        {
                                                            item?.planName
                                                        }

                                                    </td>

                                                    <td className="text-center py-3">

                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                viewPlan(
                                                                    item?.planId
                                                                )
                                                            }
                                                            className="btn btn-primary btn-sm rounded-pill px-4"
                                                        >

                                                            <i className="fe fe-eye me-2"></i>

                                                            View

                                                        </button>

                                                    </td>

                                                </tr>

                                            )
                                        )

                                    ) : (

                                        <tr>

                                            <td
                                                colSpan={
                                                    3
                                                }
                                                className="text-center py-5 text-muted"
                                            >

                                                No Plans Found

                                            </td>

                                        </tr>

                                    )}

                                </tbody>

                            </table>

                        </div>

                    </div>

                </div>

            </div>

            {/* ===================================== */}
            {/* CUSTOM PLANS */}
            {/* ===================================== */}

            <div className="col-12">

                <div className="card border-0 shadow-sm rounded-4 overflow-hidden">

                    <div className="card-header bg-white border-bottom p-4">

                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

                            <div>

                                <h4 className="fw-bold mb-1">
                                    Custom Plans
                                </h4>

                                <p className="text-muted mb-0">
                                    Employee custom quotation plans
                                </p>

                            </div>

                            <span className="badge bg-primary rounded-pill px-3 py-2">

                                Total :
                                {" "}
                                {
                                    filteredCustomPlans?.length
                                }

                            </span>

                        </div>

                    </div>

                    <div className="card-body p-4">

                        {/* SEARCH */}

                        <div className="row mb-4">

                            <div className="col-lg-3">

                                <div className="position-relative">

                                    <i
                                        className="fe fe-search position-absolute"
                                        style={{
                                            top: "50%",
                                            left: "18px",
                                            transform:
                                                "translateY(-50%)",
                                            color:
                                                "#6c757d",
                                        }}
                                    />

                                    <input
                                        type="text"
                                        className="form-control rounded-pill border-0 shadow-sm ps-5 py-3"
                                        placeholder="Search custom plans..."
                                        value={
                                            customSearch
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setCustomSearch(
                                                e
                                                    .target
                                                    .value
                                            )
                                        }
                                        style={{
                                            background:
                                                "#f8fafc",
                                        }}
                                    />

                                </div>

                            </div>

                        </div>

                        {/* TABLE */}

                        <div
                            className="table-responsive border rounded-4"
                            style={{
                                maxHeight:
                                    "500px",
                                overflowY:
                                    "auto",
                            }}
                        >

                            <table className="table align-middle mb-0">

                                <thead
                                    style={{
                                        background:
                                            "#f8fafc",
                                        position:
                                            "sticky",
                                        top: 0,
                                        zIndex: 2,
                                    }}
                                >

                                    <tr>

                                        <th className="text-center py-3">
                                            Custom ID
                                        </th>

                                        <th className="text-center py-3">
                                            Plan Name
                                        </th>

                                        <th className="text-center py-3">
                                            Employee
                                        </th>

                                        <th className="text-center py-3">
                                            Action
                                        </th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {filteredCustomPlans?.length >
                                        0 ? (

                                        filteredCustomPlans.map(
                                            (
                                                item
                                            ) => (

                                                <tr
                                                    key={
                                                        item?.id
                                                    }
                                                >

                                                    <td className="text-center fw-semibold py-3">

                                                        {
                                                            item?.id
                                                        }

                                                    </td>

                                                    <td className="text-center fw-semibold py-3">

                                                        {
                                                            item?.planName
                                                        }

                                                    </td>

                                                    <td className="text-center fw-semibold py-3">

                                                        {
                                                            item
                                                                ?.employee
                                                                ?.firstName
                                                        }{" "}

                                                        {
                                                            item
                                                                ?.employee
                                                                ?.lastName
                                                        }

                                                    </td>

                                                    <td className="text-center py-3">

                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                viewCustomPlan(
                                                                    item?.id
                                                                )
                                                            }
                                                            className="btn btn-primary btn-sm rounded-pill px-4"
                                                        >

                                                            <i className="fe fe-eye me-2"></i>

                                                            View

                                                        </button>

                                                    </td>

                                                </tr>

                                            )
                                        )

                                    ) : (

                                        <tr>

                                            <td
                                                colSpan={
                                                    4
                                                }
                                                className="text-center py-5 text-muted"
                                            >

                                                No Custom Plans Found

                                            </td>

                                        </tr>

                                    )}

                                </tbody>

                            </table>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

};